import { formatDateInputValue } from '../../utils/date-format';
import type { BuilderConditionValue } from '../segment-builder.types';
import styles from '../SegmentVisualBuilder.module.css';

export function AbsoluteDateInput({
  value,
  onChange,
  disabled,
}: {
  value: BuilderConditionValue | undefined;
  onChange: (value: BuilderConditionValue[]) => void;
  disabled?: boolean;
}) {
  const dateValue = value instanceof Date ? value : null;
  const inputValue = dateValue != null ? formatDateInputValue(dateValue) : '';

  return (
    <input
      type="date"
      className={styles.textInput}
      value={inputValue}
      onChange={e => {
        const nextValue = e.target.value;
        if (!nextValue) {
          onChange([]);
          return;
        }
        onChange([new Date(`${nextValue}T12:00:00`)]);
      }}
      disabled={disabled}
      aria-label="Date"
    />
  );
}
